<template>
  <div>
    <gg-card-title class="pt-0">
      Viewing Support Ticket #{{ ticketid }}
    </gg-card-title>
    <v-row>
      <v-col cols="12" sm="12" class="pb-0" md="12">
        <v-row>
          <v-col cols="12">
            <gg-loading :loading="loading">
              <ticket-details
                :ticket="ticket"
                :validated="!ticket.validation_required"
              />
            </gg-loading>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="6">
        <gg-loading :loading="loading" :class-list="['fill-height']">
          <ticket-reply
            :ticketid="ticketid"
            :validated="!ticket.validation_required"
            :contacts="ticket.recipients"
          />
        </gg-loading>
      </v-col>
      <v-col v-if="ticket.validation_required" cols="12" md="6">
        <ticket-validation
          :ticketid="ticketid"
          :validated="!ticket.validation_required"
        />
      </v-col>
      <v-col cols="12">
        <gg-loading :loading="loading" type="article">
          <posts :ticketid="ticketid" :posts="ticket.posts"/>
        </gg-loading>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TicketDetails from '@/components/Support/TicketSingle/TicketDetails'
// import TicketClose from '@/components/Support/TicketSingle/TicketClose'
import TicketReply from '@/components/Support/TicketSingle/TicketReply'
import Posts from '@/components/Support/TicketSingle/Posts'
import TicketValidation from '@/components/Support/TicketSingle/TicketValidation'

export default {
  name: 'TicketView',
  inject: ['theme'],
  components: {
    TicketDetails,
    // TicketClose,
    TicketReply,
    Posts,
    TicketValidation
  },
  props: {
    ticketid: {
      type: String,
      require: true
    }
  },
  data: () => ({
    domains: [],
    show_groups: ['Shared Hosting', 'Reseller Hosting', 'Virtual Private Server', 'Dedicated Server'],
    loading: true,
    transition: 'fade-transition'
  }),
  methods: {
    ...mapActions(['getTicket', 'reportError']),
    async getTicketData () {
      try {
        this.loading = true

        await this.getTicket(this.ticketid)

        this.loading = false
      } catch (e) {
        this.$router.push({
          name: 'support_ticketlist'
        })
        this.reportError(e)
      }
    },
  },
  computed: {
    ...mapGetters(['ticket', 'services', 'servicegroups']),
    serviceList () {
      return this.services.filter(item => this.show_groups.includes(item.groupname))
    }
  },
  mounted () {
    this.getTicketData()
  }
}
</script>
